<div class="modal fade show custom_popup custom_popup-ts" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">
          {{ pageTitle ? pageTitle : 'Enter Transaction' }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body padding-model form-editing">
        <div class="row transaction_popup">
          <div class="col-lg-12">
            <div class="card w-100">
              <div class="card">
                <form *ngIf="transactionUpdateForm" [formGroup]="transactionUpdateForm" (ngSubmit)="onSubmit()">
                  <div class="row">
                    <div class="width-220 field-groups">
                      <div class="mt-3">
                        <label for="transactionType" class="form-title">Transaction Type </label>
                        <div class="input-group">
                          <select
                            class="custom-form-select border-radius-100"
                            id="transactionType"
                            formControlName="transactionType"
                          >
                            <option value="" disabled selected hidden>Select</option>
                            <ng-container *ngFor="let group of transactionTypes">
                              <optgroup [label]="group.label">
                                <option *ngFor="let option of group.options" [value]="option">
                                  {{ option }}
                                </option>
                              </optgroup>
                            </ng-container>
                          </select>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="!!transactionUpdateForm.get('transactionType')?.value">
                      <div class="width-145 field-groups">
                        <div class="mt-3">
                          <label for="debtor" class="form-title text-nowrap">
                            <span class="required">*</span> Debtor
                          </label>
                          <ng-select
                            class="custom"
                            id="debtor"
                            [style.flex]="1"
                            [items]="debtors"
                            bindLabel="combinedLabel"
                            bindValue="id"
                            placeholder="Select Debtor"
                            formControlName="debtor"
                            [searchFn]="customSearch"
                            [virtualScroll]="true"
                            (change)="onCreditorChange($event)"
                          >
                            <ng-template ng-label-tmp let-item="item">
                              {{ item.name }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                              <span [title]="item.name" tooltip="item.name">{{ item.id }} - {{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                        </div>
                        <app-form-error-component [control]="transactionUpdateForm.controls['debtor']" />
                      </div>

                      <div class="width-90 field-groups">
                        <div class="mt-3">
                          <label for="date" class="form-title"><span class="required">*</span> Date </label>
                          <div class="input-group">
                            <app-date-picker id="date" formControlName="date" [maxDate]="maxDate" />
                          </div>
                          <app-form-error-component [control]="transactionUpdateForm.controls['date']" />
                        </div>
                      </div>

                      <div class="width-69 field-groups">
                        <div class="mt-3">
                          <label for="ccy" class="form-title"><span class="required">*</span> Ccy </label>
                          <select class="custom-form-select border-radius-100" id="ccy" formControlName="ccy">
                            <option value="" disabled hidden>Select</option>
                            <option *ngFor="let cc of currencyList" [value]="cc">
                              {{ cc }}
                            </option>
                          </select>
                        </div>
                        <app-form-error-component [control]="transactionUpdateForm.controls['ccy']" />
                      </div>

                      <div class="width-100 field-groups">
                        <div class="mt-3">
                          <label for="amount" class="form-title text-nowrap">
                            <span class="required">*</span> Amount
                          </label>
                          <input
                            id="amount"
                            [appOnlyNumber]="true"
                            type="text"
                            class="form-control ft-width numberText"
                            placeholder=""
                            formControlName="amount"
                            maxlength="10"
                          />
                        </div>
                        <app-form-error-component [control]="transactionUpdateForm.controls['amount']" />
                      </div>

                      <div class="width-100 field-groups">
                        <div class="mt-3">
                          <div class="form-group file-upload text-center">
                            <label for="image_file" class="form-title text-nowrap">
                              <span class="required">*</span> Transaction File
                            </label>
                            <div class="d-flex">
                              <input
                                type="file"
                                id="image_file_custom_type"
                                #fileUploader
                                (change)="fileChange($event)"
                                accept=".pdf"
                                [disabled]="disableFileChange"
                              />

                              <img
                                *ngIf="fileCtrl?.value"
                                class="ms-1 cursor-pointer"
                                src="assets/images/icon/cross-icon.svg"
                                (click)="clearFileInput(fileUploader)"
                                alt=""
                                width="10px"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <div class="col-12 bottom-fixed">
                      <hr />
                      <div class="d-flex justify-content-center mt-3">
                        <button
                          [disabled]="transactionUpdateForm.invalid"
                          type="submit"
                          class="btn btn-light me-3 btn-custom-footer save_btn"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-light btn-custom-footer cancel_btn"
                          data-dismiss="modal"
                          (click)="closeModal()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
